
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGallaboxCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxApiKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxApiSecret"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxWhatsappChannelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gallaboxApiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxApiKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gallaboxApiSecret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxApiSecret"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gallaboxWhatsappChannelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxWhatsappChannelId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gallaboxAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gallaboxAccountId"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gallaboxApiKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gallaboxApiSecret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gallaboxWhatsappChannelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gallaboxAccountId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":495}};
    doc.loc.source = {"body":"mutation updateGallaboxCredentials(\n  $gallaboxApiKey: String\n  $gallaboxApiSecret: String\n  $gallaboxWhatsappChannelId: String\n  $gallaboxAccountId: String\n) {\n  updateConfigurations(\n    input: {\n      gallaboxApiKey: $gallaboxApiKey\n      gallaboxApiSecret: $gallaboxApiSecret\n      gallaboxWhatsappChannelId: $gallaboxWhatsappChannelId\n      gallaboxAccountId: $gallaboxAccountId\n    }\n  ) {\n    gallaboxApiKey\n    gallaboxApiSecret\n    gallaboxWhatsappChannelId\n    gallaboxAccountId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateGallaboxCredentials"] = oneQuery(doc, "updateGallaboxCredentials");
        
